import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions'; 
import {API_URL} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles} from '../../../functions';
import axios from 'axios';
import ModalMultimedia from '../../Partials/ModalMultimedia';
import $ from 'jquery';

export default class EditarCertificacion extends Component {

    constructor(props) {

        super(props); 

        this.state = { 
            key: 0,
            tituloLongitud:0,
            resource: {
                cert_Titulo:"",
                cert_ArchivoAdjunto:"",
                sect_Id:0,
                ccer_Id:0,
                cert_Orden:0,
                cert_Activo:true
            },
            Validacion: {
                cert_Titulo: {
                    Error: false,                    
                },
                cert_ArchivoAdjunto: {
                    Error: false,                    
                },
                cert_Orden: {
                    Error: false,                    
                },
                ccer_Id: {
                    Error: false,                    
                },
                sect_Id: {
                    Error: false,                    
                },
                cert_Activo: {
                    Error: false,                    
                }
            },
            categorias: [],
            sectores: [],
            hasError:false,    
            hasErrorProceso:false,        
            added: false,
            security: cookie.load('user'),
            roles: [],
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);

      }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        resource.cert_ArchivoAdjunto = urlSeleccionada;

        this.setState({resource:resource});

        hideModalPageClass("divGestorArchivosCertificacion");
    }
    
    componentDidMount()
    {
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/certificaciones";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol); 
        
        const url = `${API_URL}CertificacionUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    categorias: data.result.categorias,
                    sectores: data.result.sectores
                });
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    componentWillMount(){
        
        var key = this.props.match.params.id;
        const url = `${API_URL}CertificacionUX/Seleccionar/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {
            
            this.setState({ resource: data.result, response: data, error: data.Error });           

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });
    
    }
    
    handleClickCancel(e) {
        
        if(e != undefined){
            e.preventDefault();
        }

        const {history: {push}} = this.props;    
        push('/certificaciones');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.cert_Titulo == '') {              
            newState.Validacion.cert_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cert_ArchivoAdjunto == '') {  
            newState.Validacion.cert_ArchivoAdjunto = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.ccer_Id == 0) {  
            newState.Validacion.ccer_Id = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.cert_Orden == '') {  
            newState.Validacion.cert_Orden = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}CertificacionUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'cert_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url, 
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {             
            
            if (data.data.isSucess)
            {
                let stateResponse = this.state;

                stateResponse.added = true;

                this.setState(stateResponse);

                setTimeout(() => { 
                    this.handleClickCancel();
                }, 1000);  

                setTimeout(() => { 
                    this.setState({added:false});
                }, 5000); 
            
            } else 
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => { 
                    this.setState({hasErrorProceso:false});
                }, 3000); 
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });        
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,                    
        }

        if(target.name == 'cert_Titulo'){
            tituloLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            Validacion: validaciones
        });  
    }

    render() {
        return (
            <div class="">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Certificación</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Certificación
                </div>

                {
                    this.state.hasErrorProceso ? 
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }   

                {
                    this.state.added ? 
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }             
                
                <div className="div_Modulos_Noticias">
                    <div className="txtFile x-1">
                        <input type="text" placeholder="Título" name='cert_Titulo' value={this.state.resource.cert_Titulo} maxLength={35} className={this.state.Validacion.cert_Titulo.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                        <span data-length={35}>{this.state.tituloLongitud}/35</span>
                    </div>

                    <div className="txtFile x-1 relative">
						<span className="subirImagen" data-id="txtIconoCategoria"  onClick={() => showModalPageClass("divGestorArchivosCertificacion")}></span>
                        <input type="text" placeholder="Archivo" name='cert_ArchivoAdjunto' value={this.state.resource.cert_ArchivoAdjunto} className={this.state.Validacion.cert_ArchivoAdjunto.Error ? "error" : ""}  
                        onChange={this.handleInputChange}/>
                    </div>

                    <div className="txtFile x-1">
                        <select name='ccer_Id' id='ccer_Id' onChange={this.handleInputChange} className={this.state.Validacion.ccer_Id.Error ? "error" : ""}>
                            <option value="0">Seleccionar Categoría</option>
                            {
                                this.state.categorias.length > 0 ?
                                this.state.categorias.map((categoria) => (
                                    <option value={categoria.id} selected={this.state.resource.ccer_Id == categoria.id ? true : false}>{categoria.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>                        
                    </div>

                    <div className="txtFile x-1">
                        <select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                            <option value="0">Seleccionar Sector</option>
                            {
                                this.state.sectores.length > 0 ?
                                this.state.sectores.map((sector) => (
                                    <option value={sector.id} selected={(this.state.resource.sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                ))
                                : null
                            }
                        </select>                        
                    </div>
                    
                    <div className="txtFile x-2">
                        <input type="text" placeholder="Orden" name='cert_Orden' value={this.state.resource.cert_Orden} maxLength={2} className={this.state.Validacion.cert_Orden.Error ? "error" : ""} onChange={this.handleInputChange} onChange={this.handleInputChange}/>
                    </div>

                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />
                <ModalMultimedia class="divGestorArchivosCertificacion" callback={this.getResponse.bind(this)}/>

            </div>
        )
    }
}
